import React, { createContext, useEffect, useState } from 'react';
import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useBonkGateway } from '../Hooks/useBonkGateway';

export const LiveDataBonkTokensContext = createContext<LiveDataBonkTokens | null>(null);

export function LiveDataBonkTokensProvider({ children }: React.PropsWithChildren<{}>) {
    const { bonkGatewayClient } = useBonkGateway();

    const [bonkFunTokens, setBonkFunTokens] = useState<LiveDataBonkTokens | null>(null);

    useEffect(() => {
        if (!bonkGatewayClient) return;

        bonkGatewayClient.on(Api.Bonk.Gateway.Event.PoolUpdate, async (event: Api.Bonk.DTO.LetsBonkToken) => {
            setBonkFunTokens((prevTokens) => ({
                ...prevTokens,
                [event.mint]: event,
            }));
        });

        return () => {
            bonkGatewayClient.off(Api.Bonk.Gateway.Event.PoolUpdate);
        };
    }, [bonkGatewayClient]);

    return <LiveDataBonkTokensContext.Provider value={bonkFunTokens}>{children}</LiveDataBonkTokensContext.Provider>;
}

type LiveDataBonkTokens = Record<string, Api.Bonk.DTO.LetsBonkToken>;
